import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormikLabel from "./FormLabel";

const TextAreaComponent = ({ field, errors, touched, handleFieldChange }) => {
  // Conditionally set inputProps to avoid passing undefined or false to pattern
  const inputProps = {
    ...(field.validation?.pattern ? { pattern: field.validation.pattern } : {}),
  };

  return (
    <FormControl
      fullWidth
      error={touched[field.fieldId] && !!errors[field.fieldId]}
    >
      <FormikLabel text={field.fieldName} required={field.required} />
      <Field name={field.fieldId}>
        {({ field: formikField, meta }) => (
          <TextField
            {...formikField}
            multiline // Set to multiline for text areas
            rows={field.rows || 4} // Control the number of rows (default is 4)
            placeholder={field.placeholder || field.fieldName}
            disabled={field.disabled}
            variant="outlined"
            value={formikField.value || ""}
            inputProps={inputProps} // Apply the conditional inputProps
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                borderWidth: "1px",
                cursor: field.disabled ? "not-allowed" : "inherit",
                backgroundColor:
                  field.disabled || field.readOnly ? "#f5f5f5" : "inherit",
              },
              "& .MuiInputBase-input": {
                padding: "4px",
                borderRadius: "13px",
                color: field.disabled ? "#a0a0a0" : "inherit",
                cursor:
                  field.disabled || field.readOnly ? "not-allowed" : "inherit",
                backgroundColor:
                  field.disabled || field.readOnly ? "#f5f5f5" : "inherit",
              },
            }}
            onChange={(event) => {
              if (!field.readOnly) {
                formikField.onChange(event); // Call Formik's onChange
                handleFieldChange(event, field.fieldId); // Call the change handle
              }
            }}
          />
        )}
      </Field>
      <FormHelperText>
        {touched[field.fieldId] && errors[field.fieldId]}
      </FormHelperText>
    </FormControl>
  );
};

TextAreaComponent.propTypes = {
  field: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
};

export default TextAreaComponent;
